import { useEffect, useState } from 'react';

const useZoomDetection = (): boolean => {
  const [isZoomedIn, setIsZoomedIn] = useState(false);

  useEffect(() => {
    const checkZoom = () => {
      // 1.25 corresponds to 125% zoom level (may vary by browser)
      const zoomLevel = window.devicePixelRatio;
      setIsZoomedIn(zoomLevel >= 1.25);
    };

    checkZoom(); // Check on initial load

    window.addEventListener('resize', checkZoom); // Re-check on resize
    return () => {
      window.removeEventListener('resize', checkZoom);
    };
  }, []);

  return isZoomedIn;
};

export default useZoomDetection;
